/**
 * CPG product image gallery (Swiper). Quick Shop injects HTML via fetch/append — inline
 * scripts do not run; theme.preloadProductModal calls kThemeInitCpgGallery(sectionId).
 */
(function () {
  // 防止重复加载时重置 galleries（Quick Shop 预加载会动态加载本脚本）
  if (window.__cpgGalleries) {
    return;
  }
  var galleries = {};
  window.__cpgGalleries = galleries;

  window.kThemeDestroyCpgGallery = function (sid) {
    sid = String(sid);
    var g = galleries[sid];
    if (!g) return;
    try {
      if (g.mainSwiper && typeof g.mainSwiper.destroy === 'function') {
        g.mainSwiper.destroy(true, true);
      }
      if (g.thumbsSwiper && typeof g.thumbsSwiper.destroy === 'function') {
        g.thumbsSwiper.destroy(true, true);
      }
      if (g.fullSwiper && typeof g.fullSwiper.destroy === 'function') {
        g.fullSwiper.destroy(true, true);
      }
    } catch (e) {}
    if (g._onResize) {
      window.removeEventListener('resize', g._onResize);
    }
    if (g._onVariantChange && g.container) {
      g.container.removeEventListener('variantChange', g._onVariantChange);
    }
    delete galleries[sid];
  };

  window.kThemeInitCpgGallery = function (sid) {
    sid = String(sid);
    if (typeof Swiper === 'undefined') {
      return;
    }
    if (!document.getElementById('cpg-scope-' + sid)) {
      return;
    }

    window.kThemeDestroyCpgGallery(sid);

    var g = {
      mainSwiper: null,
      thumbsSwiper: null,
      fullSwiper: null,
      container: null,
      windowWidth: window.innerWidth,
      _onResize: null,
      _onVariantChange: null,
    };
    galleries[sid] = g;

    g.container = document.querySelector('.product-section[data-section-id="' + sid + '"]');
    if (!g.container) {
      delete galleries[sid];
      return;
    }

    function updateThumbActive(idx) {
      if (!g.thumbsSwiper || !g.thumbsSwiper.slides || g.thumbsSwiper.slides.length === 0) {
        return;
      }
      var slides = g.thumbsSwiper.slides;
      slides.forEach(function (el) {
        if (el && el.classList) {
          el.classList.remove('swiper-slide-thumb-active');
        }
      });
      if (slides[idx]) {
        slides[idx].classList.add('swiper-slide-thumb-active');
        g.thumbsSwiper.slideTo(idx);
      }
    }

    function findSlideIndexByMediaId(mediaId) {
      if (!mediaId || !g.mainSwiper || !g.mainSwiper.slides) {
        return -1;
      }

      for (var i = 0; i < g.mainSwiper.slides.length; i++) {
        var slide = g.mainSwiper.slides[i];
        if (String(slide.getAttribute('data-media-id')) === String(mediaId)) {
          return i;
        }
      }

      return -1;
    }

    function goToMedia(mediaId) {
      var targetIndex = findSlideIndexByMediaId(mediaId);
      if (targetIndex < 0) {
        return false;
      }

      g.mainSwiper.slideTo(targetIndex);
      updateThumbActive(targetIndex);

      if (g.fullSwiper) {
        g.fullSwiper.slideTo(targetIndex, 0);
      }

      return true;
    }

    function initGallery() {
      var isDesktop = window.matchMedia('(min-width: 768px)').matches;

      g.thumbsSwiper = new Swiper('#cpg-scope-' + sid + ' .cpg-thumbs-swiper', {
        direction: isDesktop ? 'vertical' : 'horizontal',
        spaceBetween: 5,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        normalizeSlideIndex: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: {
          nextEl: '#t-next-' + sid,
          prevEl: '#t-prev-' + sid,
        },
        on: {
          init: function () {
            var sw = this;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                sw.update();
              });
            });
          },
        },
      });

      g.mainSwiper = new Swiper('#cpg-scope-' + sid + ' .cpg-main-swiper', {
        spaceBetween: 0,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: '#cpg-scope-' + sid + ' .cpg-main-next',
          prevEl: '#cpg-scope-' + sid + ' .cpg-main-prev',
        },
        on: {
          click: function (swiper) {
            if (swiper.clickedIndex !== undefined) {
              window.openCpgFull(sid, swiper.clickedIndex);
            }
          },
          slideChange: function () {
            this.el.querySelectorAll('video').forEach(function (v) {
              v.pause();
            });
            var activeSlide = this.slides[this.activeIndex];
            var activeV = activeSlide && activeSlide.querySelector('video');
            if (activeV) activeV.play();
            updateThumbActive(this.activeIndex);
          },
        },
      });

      updateThumbActive(0);

      // 将全屏弹窗移到 document.body，消除所有 CSS 层叠上下文/包容块干扰
      var fullEl = document.getElementById('CpgFull-' + sid);
      if (fullEl && fullEl.parentNode !== document.body) {
        document.body.appendChild(fullEl);
      }

      // 始终重建全屏 Swiper（resize 时已销毁，需重新创建）
      // 注意：全屏容器在打开前是 display:none（0×0），依赖 navigation 模块初始化
      // 极易因内部几何/启用状态不一致而出现点击 next 偶发失灵。因此不启用
      // navigation，改用下方手动绑定 slideNext/slidePrev，并在点击前先 update()。
      g.fullSwiper = new Swiper('#CpgFull-' + sid + ' .cpg-full-swiper', {
        zoom: { maxRatio: 3, minRatio: 1 },
        on: {
          slideChange: function () {
            this.el.querySelectorAll('video').forEach(function (v) {
              v.pause();
            });
            var fullActiveSlide = this.slides[this.activeIndex];
            var v2 = fullActiveSlide && fullActiveSlide.querySelector('video');
            if (v2) v2.play();
          },
        },
      });

      // 用 JS 绑定关闭按钮事件（比 inline onclick 更可靠）
      var closeBtn = document.querySelector('#CpgFull-' + sid + ' .cpg-ctrl-close');
      if (closeBtn) {
        closeBtn.onclick = function () {
          window.closeCpgFull(sid);
        };
      }

      // 手动绑定全屏左右切换按钮，规避 navigation 模块在隐藏容器初始化时的失灵
      var fullPrev = document.querySelector('#CpgFull-' + sid + ' .cpg-full-prev');
      var fullNext = document.querySelector('#CpgFull-' + sid + ' .cpg-full-next');
      if (fullPrev) {
        fullPrev.onclick = function () {
          if (!g.fullSwiper) return;
          g.fullSwiper.update();
          g.fullSwiper.slidePrev();
        };
      }
      if (fullNext) {
        fullNext.onclick = function () {
          if (!g.fullSwiper) return;
          g.fullSwiper.update();
          g.fullSwiper.slideNext();
        };
      }

      g.thumbsSwiper.on('click', function (s) {
        if (s.clickedIndex !== undefined && g.mainSwiper) {
          g.mainSwiper.slideTo(s.clickedIndex);
        }
      });
    }

    initGallery();

    if (g.container) {
      g._onVariantChange = function (evt) {
        var variant = evt && evt.detail ? evt.detail.variant : null;
        var featuredMedia = variant && variant.featured_media ? variant.featured_media : null;

        // Safe fallback: if the merchant hasn't assigned media to a variant yet,
        // keep the current gallery state unchanged.
        if (!featuredMedia || !featuredMedia.id) {
          return;
        }

        goToMedia(featuredMedia.id);
      };

      g.container.addEventListener('variantChange', g._onVariantChange);
    }

    g._onResize = function () {
      if (Math.abs(window.innerWidth - g.windowWidth) <= 20) {
        return;
      }
      g.windowWidth = window.innerWidth;
      if (g.mainSwiper) {
        g.mainSwiper.destroy(true, true);
        g.mainSwiper = null;
      }
      if (g.thumbsSwiper) {
        g.thumbsSwiper.destroy(true, true);
        g.thumbsSwiper = null;
      }
      if (g.fullSwiper) {
        g.fullSwiper.destroy(true, true);
        g.fullSwiper = null;
      }
      setTimeout(initGallery, 100);
    };
    window.addEventListener('resize', g._onResize);
  };

  window.kThemeGoToCpgMedia = function (sid, mediaId) {
    sid = String(sid);
    var g = galleries[sid];
    if (!g || !g.mainSwiper || !mediaId) {
      return false;
    }

    for (var i = 0; i < g.mainSwiper.slides.length; i++) {
      var slide = g.mainSwiper.slides[i];
      if (String(slide.getAttribute('data-media-id')) === String(mediaId)) {
        g.mainSwiper.slideTo(i);
        if (g.thumbsSwiper) {
          g.thumbsSwiper.slideTo(i);
          g.thumbsSwiper.slides.forEach(function (el) {
            if (el && el.classList) {
              el.classList.remove('swiper-slide-thumb-active');
            }
          });
          if (g.thumbsSwiper.slides[i]) {
            g.thumbsSwiper.slides[i].classList.add('swiper-slide-thumb-active');
          }
        }
        if (g.fullSwiper) {
          g.fullSwiper.slideTo(i, 0);
        }
        return true;
      }
    }

    return false;
  };

  window.openCpgFull = function (id, index) {
    var g = galleries[String(id)];
    if (!g || !g.fullSwiper) return;
    var el = document.getElementById('CpgFull-' + id);
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // 容器由 display:none 变为可见后再测算几何，避免隐藏初始化导致的布局错乱
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        g.fullSwiper.update();
        g.fullSwiper.slideTo(index, 0);
      });
    });
  };

  window.closeCpgFull = function (id) {
    var g = galleries[String(id)];
    if (!g || !g.fullSwiper) return;
    var lastIndex = g.fullSwiper.activeIndex;
    if (g.mainSwiper) g.mainSwiper.slideTo(lastIndex, 0);
    var wrap = document.getElementById('CpgFull-' + id);
    if (wrap) wrap.classList.remove('is-open');
    document.body.style.overflow = '';
    if (wrap) {
      wrap.querySelectorAll('video').forEach(function (v) {
        v.pause();
      });
    }
  };

  /** Quick Shop: modal becomes visible/layout settles — refresh Swiper direction + sizes */
  window.kThemeRefreshCpgGalleryAfterLayout = function (sid) {
    sid = String(sid);
    var g = galleries[sid];
    if (!g || !g.thumbsSwiper || !g.mainSwiper) {
      if (typeof window.kThemeInitCpgGallery === 'function') {
        window.kThemeInitCpgGallery(sid);
      }
      return;
    }
    try {
      var isDesktop = window.matchMedia('(min-width: 768px)').matches;
      var dir = isDesktop ? 'vertical' : 'horizontal';
      if (
        g.thumbsSwiper.params &&
        g.thumbsSwiper.params.direction !== dir &&
        typeof g.thumbsSwiper.changeDirection === 'function'
      ) {
        g.thumbsSwiper.changeDirection(dir);
      }
      g.thumbsSwiper.update();
      g.mainSwiper.update();
      if (g.fullSwiper) g.fullSwiper.update();
    } catch (e) {}
  };
})();
